import {
  AfterViewInit,
  Component,
  computed,
  inject,
  OnInit,
  signal,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  ColumnConfig,
  CustomAction,
  FieldType,
  GenericTableComponent,
  GlobalAction,
  HeaderConfigurationService,
  ModalFieldConfig,
  ModalMode,
  MoreDataConfig,
  TableAction,
  TableActionConfig,
} from '@solcre-org/core-ui';

@Component({
  selector: 'app-fleet-ops',
  imports: [],
  templateUrl: './fleet-ops.html'
})
export class FleetOps {

  async ngOnInit(): Promise<void> {
    document.querySelector('html')?.classList.add('s-fleet-ops-page');
  }

  ngOnDestroy(): void {
    document.querySelector('html')?.classList.remove('s-fleet-ops-page');
  }

}
